"use strict";

// Class definition
var KTWizard1 = function () {
	// Base elements
	var _wizardEl;
	var _formEl;
	var _wizard;
	var _validations = [];

	// Private functions
	var initWizard = function () {
		// Initialize form wizard
		_wizard = new KTWizard(_wizardEl, {
			startStep: 1, // initial active step number
			clickableSteps: false  // allow step clicking
		});

		// Validation before going to next page
		_wizard.on("beforeNext", function (wizard) {
			// Don't go to the next step yet
			_wizard.stop();

			//loading
			$(".form-ajax-wizard").find('.form-ajax-wizard-load').fadeIn(100);

			// Validate form
			var validator = _validations[wizard.getStep() - 1]; // get validator for currnt step
			validator.validate().then(function (status) {

				if (status == 'Valid') {
					$(".form-ajax-wizard").find('.form-ajax-wizard-load').fadeOut(100);
					_wizard.goNext();
					KTUtil.scrollTop();
				} else {
					$(".form-ajax-wizard").find('.form-ajax-wizard-load').fadeOut(100);
					Swal.fire({
						text: "Erro. Valide os campos do formulário.",
						icon: "error",
						buttonsStyling: false,
						confirmButtonText: "Ok, got it!",
						customClass: {
							confirmButton: "btn font-weight-bold btn-light"
						}
					}).then(function () {
						KTUtil.scrollTop();
					});
				}
			});
		});

		$(document).on("submit", '.form-ajax-wizard', function () {
			//console.log('submeteu aqui')

			let _this = $(this);
			let url_ajax = $(this).data("action");
			let data = $(this).serialize();

			_this.find('.form-ajax-wizard-load').fadeIn(100);

			// Don't go to the next step yet
			_wizard.stop();

			// Validate form
			var validator = _validations[_wizard.getStep() - 1]; // get validator for currnt step
			validator.validate().then(function (status) {
				if (status == 'Valid') {
					// Don't go to the next step yet					

					$('#btn_salvar_NO').attr("disabled", "disabled");
						
					$.ajax({
						type: "POST",
						headers: {
							'X-CSRF-TOKEN': CSRF_TOKEN
						},
						url: url_ajax,
						data: data,
						dataType: "json",
						success: function (data) {

							_this.find('.form-ajax-wizard-load').fadeOut(100);

							if (data.error) {
								Swal.fire({
									text: data.message,
									icon: "error",
									buttonsStyling: false,
									confirmButtonText: "Ok, got it!",
									customClass: {
										confirmButton: "btn font-weight-bold btn-light"
									}
								}).then(function () {
									KTUtil.scrollTop();
								});
							} else {
								Swal.fire({
									text: data.message,
									icon: "success",
									buttonsStyling: false,
									confirmButtonText: "Ok",
									customClass: {
										confirmButton: "btn font-weight-bold btn-light"
									}
								}).then(function () {
									KTUtil.scrollTop();
								});

								setTimeout(function () {
									window.location.href = data.result.target;
								}, 1000);
							}

							$('#btn_salvar_NO').attr("disabled", "disabled");
						},
						error: function (jqXHR, textStatus, errorThrown) {
							
							_this.find('.form-ajax-wizard-load').fadeOut(100);

							Swal.fire({
								text: "Erro de comunicação, por favor, recarregue a página",
								icon: "error",
								buttonsStyling: false,
								confirmButtonText: "Ok",
								customClass: {
									confirmButton: "btn font-weight-bold btn-light"
								}
							}).then(function () {
							});

							$('#btn_salvar_NO').attr("disabled", "disabled");

							if (APP_DEBUG != "ON") {
								setTimeout(function () {
									location.reload();
								}, 1000);
							}
						}
					});

				} else {

					_this.find('.form-ajax-wizard-load').fadeOut(100);

					Swal.fire({
						text: "Erro. Valide os campos do formulário.",
						icon: "error",
						buttonsStyling: false,
						confirmButtonText: "Ok, got it!",
						customClass: {
							confirmButton: "btn font-weight-bold btn-light"
						}
					}).then(function () {
						KTUtil.scrollTop();
					});
				}
			});

			return false;
		});

		// Change event
		_wizard.on('change', function (wizard) {
			KTUtil.scrollTop();
		});
	}

	var initValidation = function () {

		let rulesStep1 = {
			first_name: {
				validators: {
					notEmpty: {
						message: 'Nome é obrigatório'
					}
				}
			},
			phone: {
				validators: {
					notEmpty: {
						message: 'Telefone é obrigatório'
					}
				}
			}
		};

		$('div[data-wizard-type="step-content"]').each(function (index, element) {
			if (index == 0) {
				let validateInput = $(this).find('input[data-validate]');

				validateInput.each(function () {
					let rules = $(this).data('validate');

					Object.keys(rules).forEach(function (key) {
						let newRules = rulesStep1[key].validators;
						newRules[rules[key].validate] = rules[key];
					});

					if (validateInput.hasClass('valid-stringLength')) {
						let key = validateInput.attr('name');
						let newRules = rulesStep1[key].validators;
						newRules['stringLength'] = {message: 'Por favor, forneça ao menos ' + validateInput.attr('minlength') + ' caracteres.', min: validateInput.attr('minlength')};
					}
				});

			}
		});

		// Init form validation rules. For more info check the FormValidation plugin's official documentation:https://formvalidation.io/
		// Step 1
		_validations.push(FormValidation.formValidation(
			_formEl,
			{
				fields: rulesStep1,
				plugins: {
					trigger: new FormValidation.plugins.Trigger(),
					bootstrap: new FormValidation.plugins.Bootstrap()
				}
			}
		));

		// Step 2
		_validations.push(FormValidation.formValidation(
			_formEl,
			{
				fields: {
					
					description: {
						validators: {
							notEmpty: {
								message: 'Descrição é obrigatória'
							},
						}
					},
					'category_id[]': {
						validators: {
							notEmpty: {
								message: 'Empreendimento é obrigatório'
							},
						}
					}

				},
				plugins: {
					trigger: new FormValidation.plugins.Trigger(),
					bootstrap: new FormValidation.plugins.Bootstrap()
				}
			}
		));

		if ($('#step-3').length > 0) {
			// Step 3
			_validations.push(FormValidation.formValidation(
				_formEl,
				{
					fields: {
						interaction_type_id: {
							validators: {
								notEmpty: {
									message: 'Tipo de interação é obrigatório'
								}
							}
						},
						date: {
							validators: {
								notEmpty: {
									message: 'Data é obrigatório'
								}
							}
						},
						feedback: {
							validators: {
								notEmpty: {
									message: 'Observação é obrigatória'
								}
							}
						},
						contact_evaluation_id: {
							validators: {
								notEmpty: {
									message: 'Avaliação do contato é obrigatória'
								}
							}
						}
					},
					plugins: {
						trigger: new FormValidation.plugins.Trigger(),
						bootstrap: new FormValidation.plugins.Bootstrap()
					}
				}
			));

		}
	}

	return {
		// public functions
		init: function () {
			_wizardEl = KTUtil.getById('kt_wizard_crm');
			_formEl = KTUtil.getById('kt_form_crm');

			if ($('#kt_wizard_crm').length > 0) {
				initWizard();
				initValidation();
			}
		}
	};
}();

jQuery(document).ready(function () {
	KTWizard1.init();
});
